import React from "react";
import { useOutletContext } from "react-router-dom";

import { UpdateModal } from "@components/Page";
import { updateMyOrganizationOperation as operation } from "@api/services/organizations";

import getUpdateInputs from "./helpers/getUpdateInputs";

const LABEL_ENTITY = "Organization";
const LABEL_TITLE = `Edit ${LABEL_ENTITY}`;
const LABEL_SUBMIT = "Save";
const EMPTY_SECRET = "";

type Organization = Record<string, unknown> & {
  emailFooterSource?: string;
  isEmailVerified?: boolean;
  docusignWebhookSecret?: string;
};

type OutletContext = {
  indexSponsors: () => Promise<void>;
  updateOrganization: (organization: Organization) => void;
};

type Props = {
  title?: string;
  onlyFieldNames?: string[];
  modal: unknown;
  organization: Organization;
};

const OrganizationUpdateModal = ({
  title = LABEL_TITLE,
  onlyFieldNames = [],
  modal,
  organization,
}: Props): JSX.Element => {
  const { indexSponsors, updateOrganization } = useOutletContext<OutletContext>();

  const organizationWithHiddenSecret = {
    ...organization,
    docusignWebhookSecret: EMPTY_SECRET,
  };

  const inputs = getUpdateInputs(organizationWithHiddenSecret, onlyFieldNames);
  const schema = operation.getSchema(inputs);

  const onSuccess = async (newOrganization: Organization) => {
    await indexSponsors();
    updateOrganization(newOrganization);
  };

  const updateModalProps = {
    item: organizationWithHiddenSecret,
    entity: LABEL_ENTITY,
    submitLabel: LABEL_SUBMIT,
    modal,
    title,
    schema,
    onSuccess,
    operation,
  };

  return <UpdateModal {...updateModalProps} />;
};

export default OrganizationUpdateModal;
